/*
 * Copyright © 2017 TEKTELIC Communications Inc.
 */

import ProfileRoutes from './profile.routes';
import ProfileController from './profile.controller';
import ChangePasswordController from './change-password.controller';

export default angular.module('thingsboard.profile', [])
    .config(ProfileRoutes)
    .controller('ProfileController', ProfileController)
    .controller('ChangePasswordController', ChangePasswordController)
    .name;



// WEBPACK FOOTER //
// ./src/app/profile/index.js